import React, { Component, createRef } from 'react';
import useProjectStore from '../ProjectCanvas/useProjectStore';
import { TipTapEditor } from '../TipTap';

/**
 * DocumentEditor - A4 page document editor
 * 
 * Full toolbar, document (A4) styling, $ placeholders, image paste support.
 * Used by DocumentTemplate for generating documents.
 */
class DocumentEditor extends Component {
  editorRef = createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      content: '',
    };
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  }

  componentDidMount() {
    this.setState({
      content: this.normalizeContent(this.props.html),
    });
  }

  normalizeContent(html) {
    let content = html;

    if (content) {
      // Normalize table styling
      if (content.includes('table')) {
        content = content
          .replace(/(<table style=")/g, () => {
            return '<table border="1" style="border-collapse:collapse; ';
          })
          .replace(/(border-color:)/g, 'border: 1px solid');
      }
      // Handle newlines and table cell padding
      content = content
        .replace(/(?:\r\n|\r|\n)/g, '<br>')
        .replace(/(<td style="width: [0-9.]+%;">)/g, val => {
          let width = val.match(/([0-9.]+)/g)[0];
          return `<td style="width: ${width}%; padding: 4px;">`;
        });

      // Wrap in arial font if not already
      let fontStr = '<span style="font-family: arial;">';
      if (content.indexOf(fontStr) !== 0) {
        content = fontStr + content + '</span>';
      }
    } else {
      content = '';
    }

    return content;
  }

  componentDidUpdate(prevProps) {
    const { placeholder, readMe } = this.props;
    if (readMe !== true) {
      if (placeholder && placeholder.length !== prevProps.placeholder?.length) {
        this.insertPlaceholder(placeholder[placeholder.length - 1]);
      }
    }
  }

  insertPlaceholder = (placeholder) => {
    if (placeholder && this.editorRef.current) {
      this.editorRef.current.insertPlaceholder(placeholder);
      if (this.props.onFocus) {
        this.props.onFocus();
      }
    }
  };

  handleChange = (value) => {
    this.setState({ content: value });
  };

  handleBlur = (value) => {
    // Normalize table HTML on output
    let normalizedValue = value.replace(/(?:\n)/g, '');
    normalizedValue = normalizedValue
      .replace(/(<table style=")/g, () => {
        return '<table border="1" style="border-collapse:collapse; ';
      })
      .replace(/(border-color:)/g, 'border: 1px solid')
      .replace(/(<td style="width: [0-9.]+%;">)/g, val => {
        let width = val.match(/([0-9.]+)/g)[0];
        return `<td style="width: ${width}%; padding: 4px;">`;
      });

    // Wrap in arial font if not already
    let fontStr = '<span style="font-family: arial;">';
    if (normalizedValue.indexOf(fontStr) !== 0) {
      normalizedValue = fontStr + normalizedValue + '</span>';
    }

    if (this.props.onChange) {
      this.props.onChange(normalizedValue);
    }
  };

  handleFocus = () => {
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  render() {
    const { readMe, availablePlaceholders } = this.props;
    const { content, loading } = this.state;

    if (loading) {
      return (
        <div className="my-nice-tab-container">
          <div className="loading-state"></div>
        </div>
      );
    }

    // No tooltip wrapper for document editor - it interferes with click events
    return (
      <div style={{ width: '100%' }}>
        <TipTapEditor
          ref={this.editorRef}
          value={content}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          showToolbar={true}
          variant={readMe ? 'default' : 'document'}
          triggerChars={readMe ? [] : ['$']}
          availablePlaceholders={availablePlaceholders}
          projectId={useProjectStore.getState().project_id}
          placeholder=""
        />
      </div>
    );
  }
}

export default DocumentEditor;
